import React, {Component} from "react";
import PropTypes from "prop-types";
import Button from "../../components/Button";
import Api from "../../Api";
import Select from "react-select";

import "./AdminTools.less";

export default class AdminTools extends Component {
  constructor(props) {
    super(props);

    this.impersonateUser = this.impersonateUser.bind(this);
    this.importBrand = this.importBrand.bind(this);
    this.backfill = this.backfill.bind(this);
    this.onBackfillerChange = this.onBackfillerChange.bind(this);

    this.state = {
      backfillers: [],
      selectedBackfillerName: null
    };
  }

  componentWillMount() {
    Api.getBackfillers().then(
      (backfillerNames) => {
        let backfillers = [];
        backfillerNames.forEach(backfillerName => {
          backfillers.push({label: backfillerName, value: backfillerName});
        });
        this.setState({backfillers});
      },
      (error) => {
        if (error.httpStatusCode >= 500) {
          this.setState({error: 'Server error processing request'});
        } else {
          this.setState({error: 'Error: ' + error.message});
        }
      }
    );
  }

  impersonateUser() {
    let userToken = this.refs["impersonate_user_token"].value.trim();
    if (!userToken || !userToken.startsWith("u_")) {
      console.log("Invalid user token: " + userToken);
      return;
    }

    console.log("Impersonating user token: " + userToken);

    return Api.impersonateUserByToken(userToken).then(
      () => {
        this.context.router.push('/')
      },
      (error) => {
        console.log("Error impersonating user: " + error.response.message);
      }
    );
  }

  importBrand() {
    let brandUrl = this.refs["brand_url"].value.trim();
    let brandName = this.refs["brand_name"].value;

    return Api.importBrand(brandUrl, brandName).then(
      (brand) => {
        if (brand && brand.token) {
          alert("Already imported " + JSON.stringify(brand, null, 2))
        } else {
          alert("Brand importing in progress");
        }
      },
      (error) => {
        if (error.httpStatusCode >= 500) {
          this.setState({error: 'Server error processing request'});
        } else {
          this.setState({error: 'Error: ' + error.message});
        }
      }
    );
  }

  onBackfillerChange(selectedBackfiller) {
    this.setState({selectedBackfillerName: selectedBackfiller.value});
  }

  backfill() {
    if (!this.state.selectedBackfillerName) {
      alert('No backfiller selected!');
      return;
    }

    let name = this.state.selectedBackfillerName;
    let dryRun = this.refs["dry_run"].value === 'true';
    let minId = Number(this.refs["min_id"].value) || null;
    let maxId = Number(this.refs["max_id"].value) || null;
    let windowSize = Number(this.refs["window_size"].value) || null;

    return Api.backfill(name, dryRun, minId, maxId, windowSize).then(
      (message) => {
        alert(message);
      },
      (error) => {
        if (error.httpStatusCode >= 500) {
          this.setState({error: 'Server error processing request'});
        } else {
          this.setState({error: 'Error: ' + error.message});
        }
      }
    );
  }

  render() {
    return (
      <div className="tools">
        <div className="tool-section">
          <h2>Impersonate User</h2>
          <div>
            <div>User token: <input className="input" ref="impersonate_user_token" placeholder="u_a0b1c2d3"/></div>
            <div><Button onClick={this.impersonateUser}>Impersonate</Button></div>
          </div>
        </div>
        <div className="tool-section">
          <h2>Import Brand</h2>
          <div>
            <div>Brand URL: <input className="input" ref="brand_url" placeholder="http://example.com"/></div>
            <div>Brand Name: <input className="input" ref="brand_name" placeholder="Example"/></div>
            <div><Button onClick={this.importBrand}>Import</Button></div>
          </div>
        </div>
        <CsvLeads />
        <div className="tool-section">
          <h2>Backfill</h2>
          <div>

            <div>
              Backfiller: <Select name="backfiller-name"
                                  options={this.state.backfillers}
                                  onChange={this.onBackfillerChange}
                                  clearable={false}
                                  searchable={true}
                                  value={this.state.selectedBackfillerName}/>
            </div>
            <div>Dry Run: <select ref="dry_run">
              <option value="true">True</option>
              <option value="false">False</option>
            </select></div>
            <div>Min ID: <input className="input" ref="min_id" placeholder="(Optional) Min ID"/></div>
            <div>Max ID: <input className="input" ref="max_id" placeholder="(Optional) Max ID"/></div>
            <div>Window Size: <input className="input" ref="window_size" placeholder="(Optional) Window Size"/></div>
            <div><Button onClick={this.backfill}>Backfill</Button></div>
          </div>
        </div>
      </div>
    );
  }
}

AdminTools.contextTypes = {
  router: PropTypes.object
};

class CsvLeads extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      working: false,
      output: ''
    };

    this.work = this.work.bind(this);
  }

  work() {
    this.setState({
      working: true,
      output: ''
    });

    let self = this;
    let lines = this.refs.csvleads.value.split('\n');

    let returnPromise = new Promise((accept, reject) => {
      let curIdx = 0;

      function next() {
        if (curIdx >= lines.length) {
          accept();
          return;
        }

        let currentLine = lines[curIdx++];
        let ret = null;
        if (currentLine === '') {
          ret = Promise.resolve(null);
        } else {
          ret = Api.retailerFromLead(currentLine);
          ret.then(
            (retailer) => {
              let newOutput = self.state.output;
              if (newOutput.length > 0) newOutput += '\n';

              let leadUrl = `${document.location.origin}?retailer_token=${retailer.token}&campaign=1`;
              newOutput += currentLine + ',' + retailer.token + ',' + leadUrl;
              self.setState({output: newOutput});
            },
            (error) => {
              let newOutput = self.state.output;
              if (newOutput.length > 0) newOutput += '\n';

              let errorMessage = 'ERROR';
              if (typeof(error.message) === 'string') {
                errorMessage = error.message;
              } else if (typeof(error.message === 'object')) {
                errorMessage = error.message._key;
              }

              newOutput += currentLine + ',' + errorMessage;
              self.setState({output: newOutput});
            }
          );
        }

        ret.then(next, next);

        return ret;
      }

      next();
    });

    returnPromise.then(
      () => {
        this.setState({working: false});
        alert('CSV processing done.');
      }
    );

    return returnPromise;
  }

  render() {
    return (
      <div className="tool-section">
        <h2>CSV Leads</h2>
        <div>
          <div><textarea ref="csvleads" cols="80" rows="10" readOnly={this.state.working}/></div>
          <div><textarea ref="csvleads_output" cols="80" rows="10" value={this.state.output} readOnly/></div>
          <Button onClick={this.work}>Start</Button>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminTools.js
 **/